<template>
	<layout-gestao>
		<div class="row">
			<div class="col-sm-12">
				<table-data
					:route="url.getList"
					:settings="table.settings"
					:columns="table.columns"
					tableClass="table-responsive-sm"
					:inlineFilters="table.filters"
					:autoUpdateFilter="table.autoUpdateFilter"
					:addParamsToUrl="table.addParamsToUrl"
					:loadingMsg="table.loadingMsg"
					:notFoundMsg="table.notFoundMsg"
					:orderByTemplate="table.orderByTemplate"
					@error-load="showError"
					>
					<template #filters="{ tableFilters, search }">
						<form
							autocomplete="false"
							@submit.prevent=""
							@keyup.enter="search">

							<div class="row header">
								<div class="col-12">
									<header-list
										v-model="tableFilters.q"
										:title="pageTitle"
										:placeholderSearch="searchPlaceholder"
										:routeAddName="routeAddName"
										:canAdd="canAdd"
										:addTitle="addTitle"/>
								</div>
							</div>
						</form>
					</template>

					<template #body="{row, index, remove}">
						<td :class="table.columns[0].class">
							{{ columnValue(row, table.columns[0]) }}
						</td>
						<td :class="table.columns[1].class">
							{{ columnValue(row, table.columns[1]) }}
						</td>
						<column-actions
							v-if="checkActions"
							:routeEdit="routeEditName"
							:canDetail="canDetail"
							:canEdit="canEdit"
							:canDelete="canDelete"
							:row="row"
							:index="index"
							:callbackDelete="remove"
							@delete="deleteItem"/>
					</template>
				</table-data>
			</div>
		</div>
	</layout-gestao>
</template>

<script>
	import GeneralMixin from '../../mixin'

	export default {
		name: "TypeGlobalList",
		mixins: [
			GeneralMixin
		],
		props: {
			propPageID: {
				required: true,
				type: String
			}
		},
		data() {
			const pageID = 'global_types';
			return {
				pageID: pageID,
				table: {
					settings: {
						sort: 'asc',
						order_by: 'description',
					},
					columns: [
						{
							label: `${pageID}.list.order`,
							field: 'order',
							class: 'w-100px',
							sortable: true,
						},
						{
							label: `${pageID}.list.name`,
							field: 'description',
							class: '',
							sortable: true,
						},
						{
							label: '',
							field:  null,
							sortable: false,
							class: 'actions',
						}
					],
				},
			}
		},
		beforeMount() {
			this.pageID = this.propPageID;
		},
		computed: {
			moduleRoute() {
				return this.pageID;
			},
			routeAddName() {
				return `${this.moduleCode}.${this.moduleRoute}.create`;
			},
			routeEditName() {
				return `${this.moduleCode}.${this.moduleRoute}.show`;
			}
		}
	}
</script>
